import { BrandingOptions } from 'features/room/types';
import { NormalizedBrandingOptions } from 'features/branding/types';

export function normalizeBrandingOptions({
  palette,
  components,
  allowChangeLogo = false,
}: BrandingOptions): NormalizedBrandingOptions {
  return {
    palette: {
      mode: palette.mode,
      primary: {
        main: palette.primary,
      },
    },
    // The theme's deepmerge copies undefined over its defaults, so colours the team didn't send stay out.
    components: {
      ...(components?.roomBackground ? { room: { background: components.roomBackground } } : {}),
      ...(components?.toolbarBackground
        ? { toolbar: { background: components.toolbarBackground } }
        : {}),
    },
    allowChangeLogo,
  };
}
